import { render } from "./CompetitionJudge.vue?vue&type=template&id=8a48ef36&scoped=true"
import script from "./CompetitionJudge.vue?vue&type=script&lang=js"
export * from "./CompetitionJudge.vue?vue&type=script&lang=js"

import "./CompetitionJudge.vue?vue&type=style&index=0&id=8a48ef36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a48ef36"]])

export default __exports__